define("shared/components/shared/social/refresh-profile/abstract-refresh-profile-button", ["exports", "ember-concurrency/async-arrow-runtime", "@glimmer/component", "ember-concurrency"], function (_exports, _asyncArrowRuntime, _component, _emberConcurrency) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.AbstractRefreshProfileButtonComponent = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@glimmer/component",0,"ember-concurrency"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class AbstractRefreshProfileButtonComponent extends _component.default {
    constructor() {
      super(...arguments);
      /**
       * Task for refreshing a social profile through it's respective OAuth flow.
       * Also calls the parent component's provided `onProfileRefresh` callback and provides it
       * with the results of the refresh.
       */
      _defineProperty(this, "onProfileRefresh", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const socialProfile = yield this.args.socialProfile;
          this.args.onProfileRefreshStart?.(socialProfile);
          try {
            const result = yield this.handleRefresh();
            this.args.onProfileRefresh?.(socialProfile, result);
          } catch (error) {
            this.args.onProfileRefresh?.(socialProfile, {
              error
            });
          }
        }
      }), {
        drop: true
      }, "onProfileRefresh", null));
    }
    /**
     * Handler for refreshing the social profile. The return value is passed into the
     * `onProfileRefresh` callback defined in the implementing components.
     * @param args
     */
  }
  _exports.AbstractRefreshProfileButtonComponent = AbstractRefreshProfileButtonComponent;
});